import AccessLevelMixin from '@/core/application-dictionary/mixins/AccessLevelMixin';
import { AccountStoreModule } from '@/shared/config/store/account-store';
import { Component, Inject } from 'vue-property-decorator';
import { mixins } from 'vue-class-component'
import { gmapsMap, gmapsMarker } from 'x5-gmaps';
import DynamicWindowService from '@/core/application-dictionary/components/DynamicWindow/dynamic-window.service';
import dayjs from 'dayjs';

@Component({
    components: {
        gmapsMap, gmapsMarker
    }
})
export default class MapView extends mixins(AccessLevelMixin) {
    @Inject('dynamicWindowService')
    private commonService: (baseApiUrl: string) => DynamicWindowService;

    defaultZoom: number = 10;
    mapOptions: any = {
        center: { lat: -6.1877779, lng: 106.8482174 },
        zoom: 10
    }
    markers: any[] = [];

    created() {
        this.commonService('/api/trs-time-sheet-hs').retrieve({
            paginationQuery: { page: 0, size: 1000, sort: ['id'] },
            criteriaQuery: this.updateCriteria([`timesheetDate.greaterThanOrEqual=${dayjs().format('YYYY-MM-DD')}`])
        }).then((res) => {
            res.data.forEach((obj) => {
                if (obj.inGeoLat && obj.inGeoLon) {
                    this.markers.push({
                        options: {
                            position: { lat: Number.parseFloat(obj.inGeoLat), lng: Number.parseFloat(obj.inGeoLon) },
                            label: `${obj.employeeName} - Check In`,
                            title: `${obj.employeeName} - Check In`
                        }
                    })
                }
                if (obj.outGeoLat && obj.outGeoLon) {
                    this.markers.push({
                        options: {
                            position: { lat: Number.parseFloat(obj.outGeoLat), lng: Number.parseFloat(obj.outGeoLon) },
                            label: `${obj.employeeName} - Check Out`,
                            title: `${obj.employeeName} - Check Out`
                        }
                    })
                }
            });
        }).catch((err) => {
            console.log(err);
        })
    }
}